// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddToGroupComponent } from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/components/add-to-group.component';
import { AddToGroupHeaderComponent } from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/components/add-to-group-header/add-to-group-header.component';
import { AddToGroupBodyComponent } from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/components/add-to-group-body/add-to-group-body.component';
import { AddToGroupBodyListComponent } from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/components/add-to-group-body/add-to-group-body-list/add-to-group-body-list.component';
import { AddToGroupBodyEmptyComponent } from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/components/add-to-group-body/add-to-group-body-empty/add-to-group-body-empty.component';
import { AddToGroupBodyErrorComponent } from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/components/add-to-group-body/add-to-group-body-error/add-to-group-body-error.component';
import { AddToGroupBodySkeletonComponent } from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/components/add-to-group-body/add-to-group-body-skeleton/add-to-group-body-skeleton.component';
import { AddToGroupBodyCreateComponent } from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/components/add-to-group-body/add-to-group-body-create/add-to-group-body-create.component';
import { StoreModule } from '@ngrx/store';
import { addToGroupReducer, STATE_NAME } from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/store/add-to-group.reducer';
import { EffectsModule } from '@ngrx/effects';
import { AddToGroupEffects } from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/store/add-to-group.effects';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    AddToGroupComponent,
    AddToGroupComponent,
    AddToGroupHeaderComponent,
    AddToGroupBodyComponent,
    AddToGroupBodyListComponent,
    AddToGroupBodyEmptyComponent,
    AddToGroupBodyErrorComponent,
    AddToGroupBodySkeletonComponent,
    AddToGroupBodyCreateComponent,
  ],
  imports: [
    CommonModule,
    StoreModule.forFeature(STATE_NAME, addToGroupReducer),
    EffectsModule.forFeature([AddToGroupEffects]),
    TranslateModule.forChild(),
    MatIconModule,
  ],
  exports: [
    AddToGroupComponent,
  ],
})
export class AddToGroupModule {
}
